<template>
	<div class="content">
		<h3>经销商设置</h3>
		<div class="item">
			<div class="btn">
				<el-button icon="el-icon-plus" type="primary" @click="AddDealer">添加</el-button>
				<el-button icon="el-icon-search" type="primary"  @click="SelDealer(selectDealerform)">查询</el-button>
				<el-button type="primary">导出</el-button>
			</div>
			<el-form ref="selectDealerform" inline style="width:auto" :model="selectDealerform" label-width="100px">				
				<el-form-item label="省份">
					<el-select v-model="selectDealerform.provice" clearable @change="GetSelcity(selectDealerform.provice)" placeholder="请选择">
						<el-option
						v-for="item in provice"
						:key="item.PRO_CODE"
						:label="item.PRO_NAME"
						:value="item.PRO_CODE">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="城市">
					<el-select v-model="selectDealerform.city" clearable @change="GetSelregion(selectDealerform.city)" placeholder="请选择">
						<el-option
						v-for="item in Selcity"
						:key="item.CITY_CODE"
						:label="item.CITY_NAME"
						:value="item.CITY_CODE">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="区域">
					<el-select v-model="selectDealerform.region" clearable placeholder="请选择">
						<el-option
						v-for="item in Selregion"
						:key="item.AREA_CODE"
						:label="item.AREA_NAME"
						:value="item.AREA_CODE">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="经销商编号">
					<el-input v-model="selectDealerform.AgencyID" clearble></el-input>
				</el-form-item>
				<el-form-item label="经销商名称">
					<el-input v-model="selectDealerform.AgencyName" clearble></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="item" >
			<el-table :data="tableData" border>
				<el-table-column prop="DealerId" label="经销商编号"></el-table-column>
				<el-table-column prop="DealerName" label="经销商名称"></el-table-column>
				<el-table-column prop="Level" label="级别"></el-table-column>
				<el-table-column prop="Salesprovice" label="负责省份"></el-table-column>
				<el-table-column prop="Salescity" label="负责城市"></el-table-column>
				<el-table-column prop="Salesregion" label="负责地区"></el-table-column>
				<el-table-column prop="Provice" label="所在省份"></el-table-column>
				<el-table-column prop="City" label="所在城市"></el-table-column>
				<el-table-column prop="Region" label="所在地区"></el-table-column>
				<el-table-column prop="IsEnable" label="是否启用">
					<template slot-scope="scope">
						{{scope.row.IsEnable ? '启用' : '禁用'}}
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="EditWorkShop(scope)">修改</el-button>
						<el-button type="text" @click="delWorkShop(scope)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="dialogtype==1 ? '添加经销商':'编辑经销商'" @close="close" :visible.sync="dialogVisible" width="740px">
      		<el-form ref="dealerform" inline style="width:auto" :model="dealerform" :rules="rules" label-width="100px">
				<el-form-item label="经销商名称" prop="DealerName">
					<el-input v-model="dealerform.DealerName"></el-input>
				</el-form-item>
				<el-form-item :disabled="editVisible" label="经销商编号" prop="DealerId">
					<el-input v-model="dealerform.DealerId"></el-input>
				</el-form-item>
				<el-form-item label="经销商级别" prop="Level">
					<el-select v-model="dealerform.Level" placeholder="请选择级别">
						<el-option
						v-for="item in level"
						:key="item.value"
						:label="item.value"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="adress" label="所在区域" prop="provice"  style="width:740px" >
					<el-form-item style="width: auto;" prop="provice">
						<el-select v-model="dealerform.provice" style="width:180px" clearable @change="Getcity(dealerform.provice)" placeholder="请选择省份">
							<el-option
								v-for="item in provice"
								:key="item.PRO_CODE"
								:label="item.PRO_NAME"
								:value="item.PRO_CODE">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="width: auto;" prop="city">
						<el-select v-model="dealerform.city" style="width:180px" clearable @change="Getregion(dealerform.city)" placeholder="请选择城市">
							<el-option
								v-for="item in city"
								:key="item.CITY_CODE"
								:label="item.CITY_NAME"
								:value="item.CITY_CODE">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="width: auto;" prop="region">
						<el-select v-model="dealerform.region" style="width:180px" clearable placeholder="请选择地区">
							<el-option
								v-for="item in region"
								:key="item.AREA_CODE"
								:label="item.AREA_NAME"
								:value="item.AREA_CODE">
							</el-option>
						</el-select>
					</el-form-item>
                </el-form-item>
				<el-form-item class="adress1" style="width:740px"  label="负责区域" prop="saleid">
					<el-radio v-model="dealerform.saleid" :label='3'>全国</el-radio>
					<el-radio v-model="dealerform.saleid" :label='2'>仅本省</el-radio>
					<el-radio v-model="dealerform.saleid" :label='1'>仅本市</el-radio>
					<el-radio v-model="dealerform.saleid" :label='0'>自定义</el-radio>
				</el-form-item>
				<el-form-item class="adress" v-if="dealerform.saleid==0" label="自定义区域" prop="Salesprovice" style="width:740px" >
					<el-form-item style="width: auto;" prop="Salesprovice">	
						<el-select v-model="dealerform.Salesprovice"  style="width:180px" clearable @change="GetSalescity(dealerform.Salesprovice)" placeholder="请选择省份">
							<el-option
								v-for="item in provice"
								:key="item.PRO_CODE"
								:label="item.PRO_NAME"
								:value="item.PRO_CODE">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="width: auto;" prop="Salescity">
						<el-select v-model="dealerform.Salescity" style="width:180px" clearable @change="GetSalesregion(dealerform.Salescity)" placeholder="请选择城市">
							<el-option
								v-for="item in Salescity"
								:key="item.CITY_CODE"
								:label="item.CITY_NAME"
								:value="item.CITY_CODE">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="width: auto;" prop="Salesregion">
						<el-select v-model="dealerform.Salesregion" style="width:180px" clearable placeholder="请选择地区">
							<el-option
								v-for="item in Salesregion"
								:key="item.AREA_CODE"
								:label="item.AREA_NAME"
								:value="item.AREA_CODE">
							</el-option>
						</el-select>
					</el-form-item>	
                </el-form-item>
				<el-form-item label="上级经销商" prop="ParentId">
					<el-select v-model="dealerform.ParentId" clearable placeholder="请选择级别">
						<el-option
						v-for="item in parentAgency"
						:key="item.DealerId"
						:label="item.DealerName"
						:value="item.DealerId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="经销商类型" prop="Type">
					<el-select v-model="dealerform.Type" clearable placeholder="请选择类型">
						<el-option
						v-for="item in agencyType"
						:key="item.value"
						:label="item.lable"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="详细地址" prop="Address">
					<el-input v-model="dealerform.Address"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="LinkMan">
					<el-input v-model="dealerform.LinkMan"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="LinkTel">
					<el-input v-model="dealerform.LinkTel"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="IsEnable">
					<el-radio v-model="dealerform.IsEnable" :label='1'>启用</el-radio>
  					<el-radio v-model="dealerform.IsEnable" :label='0'>禁用</el-radio>
				</el-form-item>
			</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="restForm" v-if="dialogtype==1" type="warning">重 置</el-button>
        		<el-button type="primary" @click="SetDealer">保 存</el-button>
      		</span>
    	</el-dialog>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			selectDealerform: {
				provice: '',
				city: '',
				region: '',
				AgencyID: '',
				AgencyName: '',
			},
			dealerform:{
				provice: '',
				city: '',
				region: '',
				DealerId: '',
				DealerName: '',
				Level:'',
				ParentId:'',
				Type:1,
				Address:'',
				LinkMan:'',
				LinkTel:'',
				IsEnable:1,
				cid:'',
				DataId:'0',
				saleid:0,
				Salesprovice:'',
				Salescity:'',
				Salesregion:'',
			},
			rules: {
        		DealerId:[
          			{ required: true, validator: validateNumber, message: '请输入经销商编码，数字类型', trigger: 'change' }
        		],
        		DealerName:[
          			{ required: true,  message: '请输入经销商名称', trigger: 'blur' }
        		],
        		Level:[
          			{ required: true,  message: '请选择经销商级别', trigger: 'blur' }
				],
				
			},
			
			provice:[],

			Selcity:[],
			Selregion:[],

			city:[],
			region:[],

			Salescity:[],
			Salesregion:[],

			level:[
				{value:1},
				{value:2},
				{value:3}],
			parentAgency:[],
			agencyType:[{lable:'普通经销商',value:1},{lable:'商超',value:2},{lable:'门店',value:3},{lable:'其它',value:4}],
			
			tableData: [],
			dialogVisible:false,
			dialogtype:0,
			editVisible:true,
		}
	},
	mounted : function(){
		this.Getprovice();	
	},
	methods: {
		Getprovice(){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
          			action:"getprovice"
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.provice=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		},

		GetSelcity(provice){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getcity",
					  city:provice
        		}
        	}).then(res=>{
				this.selectDealerform.city=''
				this.selectDealerform.region=''
          		if(res.Code==0){
					this.Selcity=res.DataList
          		}else{
					this.Selcity=null
					this.Selregion=null
          		}       
      		})
		},
		GetSelregion(city){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getregion",
					  region:city
        		}
        	}).then(res=>{
				this.selectDealerform.region=''
          		if(res.Code==0){
					this.Selregion=res.DataList
          		}else{
					this.Selregion=null
          		}       
      		})
		},

		Getcity(provice){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getcity",
					  city:provice
        		}
        	}).then(res=>{
				this.dealerform.city=''
				this.dealerform.region=''
          		if(res.Code==0){
					this.city=res.DataList
          		}else{
					this.city=null
					this.region=null
          		}       
      		})
		},
		Getregion(city){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getregion",
					  region:city
        		}
        	}).then(res=>{
				this.dealerform.region=''
          		if(res.Code==0){
					this.region=res.DataList
          		}else{
					this.region=null
          		}       
      		})
		},

		GetSalescity(provice){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getcity",
					  city:provice
        		}
        	}).then(res=>{
				this.dealerform.Salescity=''
				this.dealerform.Salesregion=''
          		if(res.Code==0){
					this.Salescity=res.DataList
          		}else{
					this.Salescity=null
					this.Salesregion=null
          		}       
      		})
		},
		GetSalesregion(city){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getregion",
					  region:city
        		}
        	}).then(res=>{
				this.dealerform.Salesregion=''
          		if(res.Code==0){
					this.Salesregion=res.DataList
          		}else{
					this.Salesregion=null
          		}       
      		})
		},
		AddDealer(){
			this.SelParentDealer()
			this.editVisible=false
			this.dialogVisible=true;
			this.dialogtype=1;
		},
		SelDealer(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			let Province = ""
			this.provice.forEach(item => {
					if(this.selectDealerform.provice == item.PRO_CODE){
						Province = item.PRO_NAME
					}
				})
			let City = ""
			if(this.city1!=null){
				this.city.forEach(item => {
					if(this.selectDealerform.city == item.CITY_CODE){
						City = item.CITY_NAME
					}
				})
			}
			
			let Region = ""
			if(this.region!=null){
				this.region.forEach(item => {
					if(this.selectDealerform.region == item.AREA_CODE){
						Region = item.AREA_NAME
					}
				})
			}
			
			
			this.$axios({
        		method: 'post',
        		url:'/FW/Dealer.ashx',
        		params: {
					  action:"query",
					  cid:user.QyNum,
					  ProvinceID:Province,
					  CityID:City,
					  RegionID:Region,
					  AgencyID:this.selectDealerform.AgencyID,
					  AgencyName:this.selectDealerform.AgencyName
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.tableData=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		},
		SelParentDealer(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
        		method: 'post',
        		url:'/FW/Dealer.ashx',
        		params: {
					  action:"query",
					  cid:user.QyNum
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.parentAgency=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		},
		EditWorkShop(dealerform){
			this.editVisible=true
			this.dialogVisible=true;
			this.dialogtype=2;
			this.$nextTick(() => {
				this.dealerform.provice=dealerform.row.Provice;
				this.dealerform.city=dealerform.row.City;
				this.dealerform.region=dealerform.row.Region;
				this.dealerform.DealerId=dealerform.row.DealerId;
				this.dealerform.DealerName=dealerform.row.DealerName;
				this.dealerform.Level=dealerform.row.Level;
				this.dealerform.ParentId=dealerform.row.ParentId;
				this.dealerform.Address=dealerform.row.Address;
				this.dealerform.LinkMan=dealerform.row.LinkMan;
				this.dealerform.LinkTel=dealerform.row.LinkTel;
				this.dealerform.IsEnable=dealerform.row.IsEnable;
				this.dealerform.DataId=dealerform.row.DataId;
			})
		},
		close(){
			this.$refs['dealerform'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['dealerform'].resetFields()
			})
		},
		SetDealer(){
			this.$refs['dealerform'].validate((isValidate)=>{
				if(isValidate){
					var user = JSON.parse(sessionStorage.getItem('user'));
					this.dealerform.cid=user.QyNum
			this.provice.forEach(item => {
				if(this.dealerform.provice == item.PRO_CODE){
					this.dealerform.provice = item.PRO_NAME
				}
			})
			this.city.forEach(item => {
				if(this.dealerform.city == item.CITY_CODE){
					this.dealerform.city = item.CITY_NAME
				}
			})
			this.region.forEach(item => {
				if(this.dealerform.region == item.AREA_CODE){
					this.dealerform.region = item.AREA_NAME
				}
			})
			if(this.dealerform.saleid==0){
				this.provice.forEach(item => {
				if(this.dealerform.Salesprovice == item.PRO_CODE){
					this.dealerform.Salesprovice = item.PRO_NAME
				}
				})
				this.Salescity.forEach(item => {
					if(this.dealerform.Salescity == item.CITY_CODE){
						this.dealerform.Salescity = item.CITY_NAME
					}
				})
				this.Salesregion.forEach(item => {
					if(this.dealerform.Salesregion == item.AREA_CODE){
						this.dealerform.Salesregion = item.AREA_NAME
					}
				})
			}else if(this.dealerform.saleid==1){
				this.dealerform.Salesprovice = this.dealerform.provice 
				this.dealerform.Salescity = this.dealerform.city
			}else if(this.dealerform.saleid==2){
				this.dealerform.Salesprovice = this.dealerform.provice 
			}else if(this.dealerform.saleid==3){
				this.dealerform.Salesprovice = "全国"
			}

					if(this.dialogtype==1){
						//添加工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Dealer.ashx',
        			params: {
          				action:"add",
          				dealer:this.dealerform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelDealer()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}else if(this.dialogtype==2){
						//修改工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Dealer.ashx',
        			params: {
          				action:"edit",
          				dealer:this.dealerform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelDealer()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}
				}else{
					isValidate
				}
			})
		},
		delWorkShop(scope){
			this.$axios({
        				method: 'post',
        				url:'/FW/Dealer.ashx',
        			params: {
          				action:"delete",
          				dealer:scope.row
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelDealer()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 100px;
}
.el-input,.el-select{
	width:220px;
}
</style>
<style>
.adress .el-form-item__content{
	width:max-content;
}
.adress1 .el-form-item__content{
	width:600px;
}
</style>


// WEBPACK FOOTER //
// src/pages/settingDealer.vue